import React from 'react';
import { Switch } from '@hiver/hiver-ui-kit';
/**
* This file is responsible for returning a reuseable slider component
* @author Jitin
*/
const InputSlider = ({ labelName, sliderSwitched, value, id, disabled, additionalClass, isHUI=false}) => {
    let sliderClass = 'h-switch';
    id = id || 'default-3';
    if (value) {
        sliderClass = 'h-switch h-slider-on';
    }
    if (isHUI) {
        return (
            <div className={additionalClass||''}>
                <Switch
                    id={id}
                    checked={value}
                    disabled={disabled}
                    onChange={() => {
                        sliderSwitched();
                    }}
                />
                <label htmlFor={id}>{labelName}</label>
            </div>
        );
    }
    return (
        <div className={additionalClass||''}>
            <input
                type="checkbox"
                className={sliderClass}
                id={`checkbox-${id}`}
                checked={value ? true : false}
                disabled={disabled || false}
                onChange={()=>{
                    sliderSwitched();
                }}
            />
            <label htmlFor={`checkbox-${id}`}>{labelName}</label>
        </div>
    );
};

export { InputSlider };
